// @flow

import { I18n, Translate } from 'react-redux-i18n';
import React from 'react';
import BestDealBarGraph from './BestDealBarGraph';
import type { CoqueRetailer, TopWeightedSpend } from '../../../types/apolloType';
import Loader from '../../common/Loader';
import type { ShoppingCenter } from '../../../types/shoppingCenterType';
import BestDealDownloadButton from './components/BestDealDownloadButton';
import storesApi from '../../../network/api/storesApi';

type Props = {
  dispatch: () => void,
  shoppingCenter: ShoppingCenter,
  currentRetailer: CoqueRetailer,
}

type State = {
  weightedSpend: TopWeightedSpend,
  isWeightedSpendLoading: boolean,
}

class BestDealComponent extends React.Component<Props, State> {
  state = {
    weightedSpend: null,
    isWeightedSpendLoading: true,
  };

  componentDidMount() {
    this.fetchWeightedSpend(this.props.shoppingCenter, this.props.currentRetailer);
  }

  shouldComponentUpdate(nextProps: Props, nextState: State, nextContext: any): boolean {
    if (this.props.currentRetailer.branchName != nextProps.currentRetailer.branchName) {
      this.fetchWeightedSpend(nextProps.shoppingCenter, nextProps.currentRetailer);
    }

    return true;
  }

  fetchWeightedSpend = (shoppingCenter: ShoppingCenter, currentRetailer: CoqueRetailer) => {
    this.setState({ isWeightedSpendLoading: true });

    storesApi.fetchRetailerWeightedSpend(shoppingCenter.id, currentRetailer.branchName)
      .then(response => response.json())
      .then((response: TopWeightedSpend) => this.setState({ weightedSpend: response }))
      .finally(() => this.setState({ isWeightedSpendLoading: false }));
  }

  render() {
    const { weightedSpend, isWeightedSpendLoading } = this.state;
    if (isWeightedSpendLoading) {
      return (
        <Loader isLoading />
      );
    }
    return (
      <div className="bestdeal-container">
        {
          !weightedSpend
          || weightedSpend.top4SpendCategories === null
          || weightedSpend.top4SpendCategories.length === 0 ?
            (
              <Translate value="bestDeals.no_data" />
            )
            : (
              <div className="tile selected">
                <div className="bestdeal-content">
                  <p className="bestdeal-subtitle"><Translate value="bestDeals.weighted_spend" /></p>
                  <div className="bestdeal-graph">
                    <BestDealBarGraph
                      data={
                        [weightedSpend.currentSpendCategory]
                          .concat(weightedSpend.top4SpendCategories)
                      }
                      branchToFocus={this.props.currentRetailer.branchName}
                      mercuryDataYear={weightedSpend.mercuryDataYear}
                      caciDataYear={weightedSpend.caciDataYear}
                      shoppingCenter={this.props.shoppingCenter}
                    />
                  </div>
                </div>
                <div className="bestdeal-side-content">
                  <div className="tile bestdeal-recommandation">
                    {
                      weightedSpend.hasGreatPotential
                        ? (
                          <>
                            <p className="outcome outcome--welldone">
                              <i className="fas fa-thumbs-up" />
                              <Translate value="bestDeals.welldone" />
                            </p>
                            <p>
                              {
                                I18n.t(
                                  'bestDeals.welldone_description',
                                  { retailerName: this.props.currentRetailer.retailerName },
                                )
                              }
                            </p>
                          </>
                        )
                        :
                        (
                          <>
                            <p className="outcome outcome--warning">
                              <i className="fas fa-exclamation-triangle" />
                              <Translate value="bestDeals.warning" />
                            </p>
                            <p>
                              {
                                I18n.t(
                                  'bestDeals.warning_description',
                                  {
                                    retailerName: this.props.currentRetailer.retailerName,
                                    branchLevelName: weightedSpend.top4SpendCategories[0].name || '',
                                  },
                                )
                              }
                            </p>
                          </>
                        )
                    }
                    <p>
                      {I18n.t('bestDeals.other_sc_suggested')}
                    </p>
                    <p className="category">{weightedSpend.otherSpendCategoriesSuggested.join(', ')}</p>
                    <div className="bestdeal-download">
                      <BestDealDownloadButton
                        dispatch={this.props.dispatch}
                        pcId={this.props.shoppingCenter.id}
                        shoppingCenterName={this.props.shoppingCenter.name}
                      />
                    </div>
                  </div>
                </div>

              </div>
            )
        }
      </div>
    );
  }
}

export default BestDealComponent;
